import { defineStore } from 'pinia'
import { IAuth } from '../models/auth'
import apiClient from '../services/http'
const appName = import.meta.env.VITE_APP_BUILD_NAME
export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token') || '',
    role: '',
  }),
  getters: {
    isAuthenticated: (state) => !!state.token,
    getUserData: (state) => {
      function parseJwt(token: any) {
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join(''),
        )
        return JSON.parse(jsonPayload)
      }
      return parseJwt(state.token)
    },
  },
  actions: {
    logout() {
      this.token = ''
      localStorage.removeItem('token')
      if (document.location.href.split('#')[1] !== 'auth/login') {
        document.location.href = document.location.href.split('#')[0]
      }
    },
    login(data: IAuth) {
      return new Promise((resolve, reject) => {
        apiClient
          .get('/api/login?app='+appName+'&password=' + data.pwd + '&user=' + data.login)
          .then((res: any) => {
            const token = res.data?.Response?.Token ? res.data.Response.Token : res.data.response.token
            localStorage.setItem('token', token)
            this.token = token
            resolve(token)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
})
